// *** Forgot Password Component ****
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import "../../assets/css/forgotpswd.css";
import Validation from "../../commonComponents/Validation";
import emailimg from "../../assets/img/emails 1.svg";
import sussecimg from "../../assets/img/success 1.svg";
import PasswordReset from "../../commonComponents/PasswordReset";

const ResetPopUp = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [loader, setLoader] = useState(false);
    const [error, setError] = useState(false);
    const [emailError, setEmailError] = useState(false);


    return (
        <div>
            <PasswordReset
            image="success"
            title="Password Changed"
            content= "Your password has been updated successfully."/>
        </div>
    );
};
export default ResetPopUp;

